import helperStyles from "@src/components/helpers.module.scss";
import React from "react";

const PlusIconThemed = () => {
	return (
		<div className={helperStyles.iconContainer}>
			<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M14.7422 8.5C14.7422 8.60567 14.7002 8.70702 14.6255 8.78174C14.5508 8.85646 14.4494 8.89844 14.3438 8.89844H8.89844V14.3438C8.89844 14.4494 8.85646 14.5508 8.78174 14.6255C8.70702 14.7002 8.60567 14.7422 8.5 14.7422C8.39433 14.7422 8.29298 14.7002 8.21826 14.6255C8.14354 14.5508 8.10156 14.4494 8.10156 14.3438V8.89844H2.65625C2.55058 8.89844 2.44923 8.85646 2.37451 8.78174C2.29979 8.70702 2.25781 8.60567 2.25781 8.5C2.25781 8.39433 2.29979 8.29298 2.37451 8.21826C2.44923 8.14354 2.55058 8.10156 2.65625 8.10156H8.10156V2.65625C8.10156 2.55058 8.14354 2.44923 8.21826 2.37451C8.29298 2.29979 8.39433 2.25781 8.5 2.25781C8.60567 2.25781 8.70702 2.29979 8.78174 2.37451C8.85646 2.44923 8.89844 2.55058 8.89844 2.65625V8.10156H14.3438C14.4494 8.10156 14.5508 8.14354 14.6255 8.21826C14.7002 8.29298 14.7422 8.39433 14.7422 8.5Z"
					fill="currentColor"
				/>
			</svg>
		</div>
	);
};

export default PlusIconThemed;
